module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-22.c90f3a41.png";